import { Nullish } from './helperTypes';

export function isNotNullish<T>(value: Nullish<T>): value is T {
  return value !== undefined && value !== null;
}

export const getNonNullishValuesArray = <T>(...values: Nullish<T>[]): T[] => values.filter(isNotNullish);
